import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import auth from "./services/Auth";
import LoginContainer from "./pages/Login";
import HomeContainer from "./pages/Home";
import ChangePasswordContainer from "./pages/ChangePassword";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (auth.isAuthenticated()) {
        return <Component {...props} exact />;
      }

      // Se tiver "id" nos parâmetros, significa que é rota de revenda
      const resaleId = props.match?.params?.id;
      if (resaleId) {
        return (
          <Redirect
            to={{
              pathname: `/${resaleId}/login`,
              state: { from: props.location },
            }}
          />
        );
      }

      // Caso padrão (não é revenda)
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);


const Routes = () => (
  <BrowserRouter>
  <Switch>
    {/* Login */}
    <Route exact path="/" component={LoginContainer} />
    <Route exact path="/:id/login" component={LoginContainer} />

    {/* Reset de senha */}
    <Route exact path="/passwordReset" component={ChangePasswordContainer} />

    {/* Home genérica */}
    <PrivateRoute path="/home" component={HomeContainer} />

    {/* Home com revenda */}
    <PrivateRoute path="/:id" component={HomeContainer} />
    <PrivateRoute path="/:id/home" component={HomeContainer} />

    {/* fallback */}
    <Redirect to="/" />
  </Switch>
</BrowserRouter>
);

export default Routes;